import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const emphysema: AnswerPathTreeNode = {
  path: 'emphysema',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredEmphysemaDetails }],
};
